export default __webpack_public_path__ + "static/media/productfold.551085d4.png";